import { Section } from 'src/components/shared/SectionV2'
import ImgComponent from 'src/components/shared/Img'
import { ScheduleACallCTA } from 'src/components/shared/ScheduleACallCTA'

const Img = ImgComponent as any // Img is a JS component with no type declarations

const steps = [
  'Get your questions answered by a debt expert',
  'Talk through options that fit your budget and goals',
  'Walk away with clarity—not a commitment',
]

const chips = ['✓ Free', '✓ No obligation', '✓ Flexible scheduling']

const TalkToARealPersonSection = () => {
  return (
    <Section
      variant="primary"
      id="talk-to-a-real-person"
      className="flex justify-center gap-8"
    >
      <div className="md:max-w-133 w-full">
        <Section.Typography
          variant="heading-large"
          as="h2"
          className="mb-4 lg:text-left"
        >
          Get debt relief options tailored to your situation
        </Section.Typography>

        <Section.Typography variant="body-small" className="mb-8 lg:text-left">
          Debt can feel overwhelming—understanding your options doesn´t have to
          be. A call with an expert can help.
        </Section.Typography>

        <div className="my-6 flex items-center justify-center lg:hidden">
          <Img
            src="/next-assets/talk-to-a-real-person-section/schedule-a-call-mobile.webp"
            alt="Talk to a real person"
            width={223}
            height={226}
            unoptimized
            layout="intrinsic"
          />
        </div>

        <div className="mb-4 lg:mb-8">
          {steps.map((item, index) => (
            <div
              key={index}
              className="relative flex items-start gap-4 pb-4 last:pb-0"
            >
              {index !== steps.length - 1 && (
                <span className="absolute top-6 left-3 h-full w-0.5 -translate-x-1/2 bg-[#EEF3FC]" />
              )}
              <div className="size-6 relative z-10 flex shrink-0 items-center justify-center rounded-full bg-[#EEF3FC] font-medium text-content-accent">
                {index + 1}
              </div>
              <Section.Typography
                variant="label-medium"
                as="span"
                className="text-left leading-6"
              >
                {item}
              </Section.Typography>
            </div>
          ))}
        </div>

        <div className="flex w-full flex-col gap-1 lg:w-fit">
          <ScheduleACallCTA
            nav_link_section="Schedule a call component"
            page_section="Get debt relief options tailored to your situation"
            variant="contained"
          />

          <div className="flex items-center justify-center gap-2">
            {chips.map((item, index) => (
              <span
                key={index}
                className="text-12 font-normal leading-none text-content-primary"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>

      <Img
        src="/next-assets/talk-to-a-real-person-section/schedule-a-call-desktop.webp"
        alt="Talk to a real person"
        width={350}
        height={385}
        unoptimized
        className="hidden lg:block"
        layout="intrinsic"
      />
    </Section>
  )
}

export { TalkToARealPersonSection }
